import TabBar from "../../../components/tabbar/TabBar";
import { Outlet } from "react-router-dom";
import { Suspense, useState } from "react";
import { useDispatch } from "react-redux";
import { searchPatient } from "../../../redux/searchState/searchActions";
import SearchIcon from "@mui/icons-material/Search";

const INVOICE_TABS = [
  { path: "all-invoices", title: "All Invoices" },
  { path: "due-invoices", title: "Due Invoices" },
  { path: "advanced", title: "Advance" },
  { path: "completed", title: "Completed" },
];

function AllPayments() {

  return (
    <div className="space-y-2.5">
      <TabBar items={INVOICE_TABS} title="Invoices List"/>

      <Suspense
        fallback={
          <div className="flex items-center justify-center py-10">
            <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </div>
  );
}

export default AllPayments;
